export const theme = {
  colors: {
    bg: 0x0A0A0F,
    grid: 0x1A1A2E,
    beaconIdle: 0x2D2D44,
    flashGranted: 0x00FF88,
    flashDenied: 0xFF3366,
    agentGhost: 0x4A9EFF,
    agentGhostOpacity: 0.5,
    agentReal: 0xFFD700,
    aura: 0xFFFFFF,
    trail: 0x4A9EFF,
    beam: { start: 0x4A9EFF, end: 0x00FF88 },
    label: 0xFFFFFF,
    hud: 0xAAAAAA,
  },
  fonts: {
    mono: 'JetBrains Mono, monospace',
    label: 'Inter, system-ui, sans-serif',
  },
  sizes: {
    agentRadius: 6,
    beaconRadius: 16,
    beaconFlashScale: 1.6,
    portRadius: 28,
    auraMaxRadius: 40,
    trailLength: 30,
    beamWidth: 2,
  },
  animation: {
    beaconIdlespeed: 0.005,
    beaconPulseMs: 300,
    beamFadeMs: 500,
    trailDecayMs: 2000,
    agentMaxSpeed: 2,
    realAgentMaxSpeed: 4,
    acceleration: 0.08,
    friction: 0.96,
  },
};
